<template>
    <div class="addresss">
        <div class="contacts">
            <b-form-group
                class="email"
                label-for="email-input"
                label="email">
                <template #label>
                    {{ personalInternship ? $t('internship.mail_supervisor') + ':' : $t('common.email')+':' }}
                </template>
                <b-form-input
                    id="email"
                    v-model="email"
                    :placeholder="personalInternship ? $t('internship.mail_supervisor') + ':' : $t('common.email')+':'"
                    @change="updateContactData()">
                </b-form-input>
            </b-form-group>
            <b-form-group
                class="phone"
                label-for="phone-input"
                :label="personalInternship ? $t('internship.phone_supervisor')+':' : $t('common.phone_number')+':'">
                <b-form-input
                    id="phone"
                    v-model="phone"
                    :placeholder="personalInternship ? $t('internship.phone_supervisor')+':' : $t('common.phone_number')+':'"
                    @change="updateContactData()">
                </b-form-input>
            </b-form-group>
        </div>

        <div class="street">
            <b-form-group
                class="street-name-group"
                label-for="street-input"
                :label="$t('common.input.street')">
                <template #label> {{ $t('common.input.street_name') }} <span class="required">*</span> </template>
                <b-form-input
                    id="street-input"
                    v-model="street"
                    :placeholder="$t('common.input.street_name')"
                    @change="updateContactData()">
                </b-form-input>
            </b-form-group>
            <b-form-group
                class="street-number"
                label-for="street-number-input"
                :label="$t('common.input.house_number')">
                <template #label> {{ $t('common.input.house_number') }} <span class="required">*</span> </template>
                <b-form-input
                    id="street-number-input"
                    v-model="streetNumber"
                    :placeholder="$t('common.input.house_number')"
                    @change="updateContactData()">
                </b-form-input>
            </b-form-group>
        </div>

        <div class="place">
            <b-form-group
                class="zipcode"
                label-for="zipcode-input"
                :label="$t('common.input.postal_code')">
                <template #label>{{$t('common.input.postal_code')}}: <span class="required">*</span> </template>
                <b-form-input
                    id="zipcode"
                    v-model="zipcode"
                    placeholder="1234AB"
                    maxlength="6"
                    @change="updateContactData()">
                </b-form-input>
            </b-form-group>

            <b-form-group
                class="city"
                label-for="city-input"
                :label="$t('common.input.place_name')">
                <template #label> {{ $t('common.input.place_name') }} <span class="required">*</span> </template>
                <b-form-input
                    id="city-input"
                    v-model="city"
                    :placeholder="$t('common.input.place_name')"
                    @change="updateContactData()">
                </b-form-input>
            </b-form-group>

            <b-form-group
                class="country"
                v-if="!disableCountry"
                :label="$t('common.input.country')"
                label-for="country-input">
                <b-form-input
                    id="country"
                    v-model="country"
                    :placeholder="$t('common.input.country')"
                    :label="$t('common.input.country')"
                    @change="updateContactData()">
                </b-form-input>
            </b-form-group>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-apprentice-address-form-component',
        props: {
            disableCountry: {
                type: Boolean,
                default: true,
            },
            contactDataIn: {
                type: Object,
                default: null,
            },
            personalInternship: {
                type: Boolean,
                default: false,
                required: false,
            },
        },
        data() {
            return {
                city: this.contactDataIn ? this.contactDataIn.city : '',
                street: this.contactDataIn ? this.contactDataIn.street : '',
                streetNumber: this.contactDataIn ? this.contactDataIn.streetNumber : '',
                zipcode: this.contactDataIn ? this.contactDataIn.zipcode : '',
                country: this.contactDataIn ? this.contactDataIn.country : '',
                phone: this.contactDataIn ? this.contactDataIn.phone : '',
                email: this.contactDataIn ? this.contactDataIn.email : '',
            };
        },
        methods: {
            updateContactData() {
                this.$emit('contactData', this.$data);
            },
        },
        watch: {
            contactDataIn() {
                this.city = this.contactDataIn ? this.contactDataIn.city : '';
                this.street = this.contactDataIn ? this.contactDataIn.street : '';
                this.streetNumber = this.contactDataIn ? this.contactDataIn.streetNumber : '';
                this.zipcode = this.contactDataIn ? this.contactDataIn.zipcode : '';
                this.country = this.contactDataIn ? this.contactDataIn.country : '';
                this.phone = this.contactDataIn ? this.contactDataIn.phone : '';
                this.email = this.contactDataIn ? this.contactDataIn.email : '';
            },
        },
    };
</script>

<style scoped lang="scss">
    .form-group {
        input {
            margin-bottom: 0;
        }
    }

    .place {
        display: grid;
        align-items: center;
        grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
        column-gap: $grid-gutter-width;
    }

    @media (min-width: map-get($grid-breakpoints, 'lg')) {
        .street,
        .contacts {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            justify-content: flex-start;
            column-gap: $grid-gutter-width;
        }

        .street {
            .street-name-group {
                flex: 1 0 auto;
            }

            .street-number-group {
                flex: 0 1 15%;
            }
        }

        .contacts {
            .form-group {
                flex: 1 1 calc(50% - 15px);
            }
        }
    }
</style>
